<div class="container" style="background-color: white; padding: 20px; margin-top: 15px;">
  <div class="row">
    <div class="col-12">
      <h4 style="margin-bottom: 8px;">FollowUp Bulk Excel Upload</h4>
      <p style="font-size: 13px; color: #555;">
        Download the Excel format, share with client, fill rows, then upload.
        Followups will be created under the logged-in user
        (<b>{{ login_Details?.name }}</b>).
      </p>
      <p style="font-size: 12px; color: #777;">
        Required columns:
        <b>acc_no, log_type, mstatus, substatus, remarks, fdate</b>.
        For PTP also fill <b>ptp_amount</b> and <b>ptp_date</b> (YYYY-MM-DD).
        <b>passport_no</b> is optional (use it only if one acc_no has multiple customers).
        Fintresle ID is picked automatically from allocation details using acc_no.
      </p>
    </div>
  </div>

  <div class="row" style="margin-top: 10px; align-items: center;">
    <div class="col-md-4">
      <button class="btn btn-sm btn-primary" type="button" (click)="downloadFollowupExcelTemplate()">
        Download Excel Format
      </button>
    </div>
    <div class="col-md-5">
      <input type="file" accept=".xlsx,.xls" (change)="onBulkExcelSelected($event)">
    </div>
    <div class="col-md-3" style="text-align: right;">
      <button class="btn btn-sm btn-success" type="button"
        [disabled]="bulkUploadLoader || !bulkExcelRows.length"
        (click)="uploadBulkFollowupExcel()">
        {{ bulkUploadLoader ? 'Uploading...' : 'Upload FollowUps' }}
      </button>
    </div>
  </div>

  <div class="row" style="margin-top: 15px;" *ngIf="bulkExcelRows.length">
    <div class="col-12">
      <p><b>Rows ready to upload:</b> {{ bulkExcelRows.length }}</p>
      <div style="max-height: 320px; overflow: auto; border: 1px solid #ddd;">
        <table class="table table-sm table-bordered" style="margin-bottom: 0; font-size: 12px;">
          <thead>
            <tr>
              <th>#</th>
              <th>acc_no</th>
              <th>passport_no</th>
              <th>log_type</th>
              <th>mstatus</th>
              <th>substatus</th>
              <th>fdate</th>
              <th>remarks</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of bulkExcelRows; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ row.acc_no }}</td>
              <td>{{ row.passport_no }}</td>
              <td>{{ row.log_type }}</td>
              <td>{{ row.mstatus }}</td>
              <td>{{ row.substatus }}</td>
              <td>{{ row.fdate }}</td>
              <td>{{ row.remarks }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="row" style="margin-top: 15px;" *ngIf="bulkUploadResult">
    <div class="col-md-6">
      <p style="color: green;"><b>Success:</b> {{ bulkUploadResult.success_count }}</p>
    </div>
    <div class="col-md-6">
      <p style="color: red;"><b>Failed:</b> {{ bulkUploadResult.failed_count }}</p>
    </div>
    <div class="col-12" *ngIf="bulkUploadResult.failed?.length">
      <div style="max-height: 220px; overflow: auto; border: 1px solid #f5c2c7;">
        <table class="table table-sm table-bordered" style="margin-bottom: 0; font-size: 12px;">
          <thead>
            <tr>
              <th>Row</th>
              <th>acc_no</th>
              <th>finterstal_id</th>
              <th>passport_no</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of bulkUploadResult.failed">
              <td>{{ item.row }}</td>
              <td>{{ item.acc_no }}</td>
              <td>{{ item.finterstal_id }}</td>
              <td>{{ item.passport_no }}</td>
              <td>{{ item.reason }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
